module.exports = __webpack_public_path__ + "img/icon-stats-contacts.cf71cbd3.svg";